import React from "react";
import {css} from "@emotion/react";

import {calculateRemSize, position, w100} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

const chartPopup = require("../images/chart_popup.svg");

interface IProps {
    className?: string;
    text: React.ReactNode;
}

export const ContractorDescriptionPopup = (props: IProps) => {
    return (
        <div css={position("absolute")} className={props.className}>
            <img alt="chart bar" css={img} src={chartPopup} />

            <Text align="center" css={text} color="#fff" variant="body_copy_2">
                {props.text}
            </Text>
        </div>
    );
};

const text = css`
    ${w100};
    position: absolute;
    top: ${calculateRemSize(1.5)};
    left: 0;
    text-transform: uppercase;
`;

const img = css`
    width: 15rem;
    height: 10rem;
`;
import React from "react";
import {css} from "@emotion/react";

import {calculateRemSize, position, w100} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

const chartPopup = require("../images/chart_popup.svg");

interface IProps {
    className?: string;
    text: React.ReactNode;
}

export const ContractorDescriptionPopup = (props: IProps) => {
    return (
        <div css={position("absolute")} className={props.className}>
            <img alt="chart bar" css={img} src={chartPopup} />

            <Text align="center" css={text} color="#fff" variant="body_copy_2">
                {props.text}
            </Text>
        </div>
    );
};

const text = css`
    ${w100};
    position: absolute;
    top: ${calculateRemSize(1.5)};
    left: 0;
    text-transform: uppercase;
`;

const img = css`
    width: 15rem;
    height: 10rem;
`;
